/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { isValid, parse } from 'date-fns';

/* eslint-disable import/prefer-default-export */

// Ideally these should come from content stack
const occasionList = {
    1: { desc: 'Anniversary', id: 1 },
    2: { desc: 'Birthday', id: 2 },
    4: { desc: 'Just Because', id: 4 },
    5: { desc: 'Valentine’s Day', id: 5 },
    6: { desc: 'Easter', id: 6 },
    7: { desc: 'Mother’s Day', id: 7 },
    8: { desc: 'Father’s Day', id: 8 },
    9: { desc: 'Thanksgiving', id: 9 },
    10: { desc: 'Christmas', id: 10 },
    11: { desc: 'Parent\'s Day', id: 11 },
    12: { desc: 'Friendship Day', id: 12 },
    13: { desc: 'New Year’s', id: 13 },
    14: { desc: 'Halloween', id: 14 },
    15: { desc: 'Veteran’s Day', id: 15 },
    16: { desc: 'Memorial Day', id: 16 },
    17: { desc: 'Cinco de Mayo', id: 17 },
    18: { desc: 'Hannukah', id: 18 },
    19: { desc: 'Boss Day', id: 19 },
    20: { desc: 'Eid', id: 20 },
    21: { desc: 'Diwali', id: 21 },
};

// Ideally this is dynamic based on the occastion list above
const holidayOccasionList = {
    5: { desc: 'Valentine’s Day', id: 5 },
    6: { desc: 'Easter', id: 6 },
    7: { desc: 'Mother’s Day', id: 7 },
    8: { desc: 'Father’s Day', id: 8 },
    9: { desc: 'Thanksgiving', id: 9 },
    10: { desc: 'Christmas', id: 10 },
    11: { desc: 'Parent\'s Day', id: 11 },
    12: { desc: 'Friendship Day', id: 12 },
    13: { desc: 'New Year’s', id: 13 },
    14: { desc: 'Halloween', id: 14 },
    15: { desc: 'Veteran’s Day', id: 15 },
    16: { desc: 'Memorial Day', id: 16 },
    17: { desc: 'Cinco de Mayo', id: 17 },
    18: { desc: 'Hannukah', id: 18 },
    19: { desc: 'Boss Day', id: 19 },
    20: { desc: 'Eid', id: 20 },
    21: { desc: 'Diwali', id: 21 },
};

export const isOccasionHoliday = (occasionId) => occasionId in holidayOccasionList;

export const buildRecipientPayload = ({ recipients, customer, brandId, email }) => {
    const { firstName, lastName } = customer;
    return recipients.map((recipient) => ({
        rcpEmail: email,
        firstName: recipient?.rcpFirstName || '',
        lastName: recipient?.rcpLastName || '',
        rcpFirstName: recipient?.rcpFirstName || '',
        rcpLastName: recipient?.rcpLastName || '',
        occasions: recipient?.occasions?.map((occasion) => {
            const [dateMM, dateDD] = (occasion?.date || '').split('/');
            return {
                brandId: brandId || '1001',
                createdUser: 'SSP',
                custFirstName: firstName || '',
                custLastName: lastName || '',
                occasion: occasion?.occasion || '',
                dateDD: dateDD || '',
                dateMM: dateMM || '',
                dateYYYY: '',
                desc: occasionList[occasion?.occasion]?.desc || '',
                reminderEmail: email,
                reminderPhone: '',
                subscribed: true,
                subscribedEmail: true,
                subscribedPhone: false,
            };
        }) || [],
    }));
};

export const getOccasionList = () => {
    const occasionsMapped = [{
        occasion: '',
        desc: 'Occasion',
        dateMM: '',
        dateDD: '',
        dateYYYY: '',
        occasionId: '',
        reminderPhone: '',
        reminderEmail: '',
        subscribedEmail: false,
        subscribedPhone: false,
        subscribed: false,
    }];

    if (Object.keys(occasionList).length > 0) {
        Object.entries(occasionList)?.forEach(([_, occasion]) => {
            occasionsMapped.push({
                occasion: occasion.id,
                desc: occasion.desc,
                dateMM: '',
                dateDD: '',
                dateYYYY: '',
                occasionId: '',
                reminderPhone: '',
                reminderEmail: '',
                subscribedEmail: false,
                subscribedPhone: false,
                subscribed: false,
            });
        });
    }

    return occasionsMapped;
};

export const isValidDate = (dateStr) => {
    const mmDdRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
    if (!mmDdRegex.test(dateStr)) {
        return false;
    }
    // If the date has a valid format, I'm revalidating using date-fns
    const [month, day] = dateStr.split('/');
    const currentYear = new Date().getFullYear();
    const date = parse(`${month}/${day}/${currentYear}`, 'MM/dd/yyyy', new Date());
    return isValid(date);
};